import Get5SevenStoriesIntro from './Get5SevenStoriesIntro'
export default Get5SevenStoriesIntro
